export function getAll() {
  var items = [
    {
      value: true,
      name: "All",
      text: "全部",
    },
    {
      value: false,
      name: "Moved",
      text: "僅異動",
    },
  ];
  return items;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
